export var getTzip10Link = function getTzip10Link(url, payload) {
  return "".concat(url, "?type=tzip10&data=").concat(payload);
};